/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_HeadingInputs */

const en_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design, build, and ship modern applications.`)
};

const ar_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صمّم، ابنِ، وأطلق تطبيقات عصرية.`)
};

const bn_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আধুনিক অ্যাপ ডিজাইন করুন, তৈরি করুন, লঞ্চ করুন।`)
};

const de_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderne Anwendungen entwerfen, bauen und veröffentlichen.`)
};

const es_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseña, construye y lanza aplicaciones modernas.`)
};

const fr_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concevoir, construire et lancer des applications modernes.`)
};

const pt_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projete, construa e lance aplicações modernas.`)
};

const zh_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设计、构建和交付现代应用程序。`)
};

const tr_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern uygulamalar tasarlayın, geliştirin ve çıkarın.`)
};

const ru_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проектируйте, создавайте и выпускайте современные приложения.`)
};

const pl_notes_heading = /** @type {(inputs: Notes_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektuj, buduj i dostarczaj nowoczesne aplikacje.`)
};

/**
* | output |
* | --- |
* | "Design, build, and ship modern applications." |
*
* @param {Notes_HeadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const notes_heading = /** @type {((inputs?: Notes_HeadingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_HeadingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_notes_heading(inputs)
	if (locale === "bn") return bn_notes_heading(inputs)
	if (locale === "de") return de_notes_heading(inputs)
	if (locale === "es") return es_notes_heading(inputs)
	if (locale === "fr") return fr_notes_heading(inputs)
	if (locale === "pt") return pt_notes_heading(inputs)
	if (locale === "zh") return zh_notes_heading(inputs)
	if (locale === "tr") return tr_notes_heading(inputs)
	if (locale === "ru") return ru_notes_heading(inputs)
	if (locale === "pl") return pl_notes_heading(inputs)
	return en_notes_heading(inputs)
});